/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_links = ReadonlyArray<{
    readonly url: string | null;
    readonly anchorText: string | null;
    readonly " $refType": "SharedMobileLinksBlock_links";
}>;
export type SharedMobileLinksBlock_links$data = SharedMobileLinksBlock_links;
export type SharedMobileLinksBlock_links$key = ReadonlyArray<{
    readonly " $data"?: SharedMobileLinksBlock_links$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileLinksBlock_links">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedMobileLinksBlock_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorText",
      "storageKey": null
    }
  ],
  "type": "InternalBuyLinkType",
  "abstractKey": null
};
(node as any).hash = 'b874354a2f6be93bf31a6cf3252d5c8e';
export default node;
